/** ---------------------------------------------------------------------------------------
 * --  LICENSE AGREEMENT -- *
 This software is licensed under the following terms:

 * -- GRANT OF LICENSE | RESTRICTIONS -- *
 Subject to the terms and conditions of this license, the copyright holders
 hereby grant you a non-exclusive, non-transferable, revocable license to use,
 copy, modify, and distribute the software.
 You are expressly prohibited from selling or commercially exploiting the software.
 Unauthorized use, reproduction, or distribution of the software, or any part
 thereof, is strictly prohibited.

 * -- AUTHORIZED USERS | INTELLECTUAL PROPERTY -- *
 This license is granted only to the individual or entity to whom the software is
 directly distributed by the copyright holders. Any use by other individuals or
 entities is unauthorized and in violation of this license. The software is
 protected by copyright and other intellectual property laws.
 The copyright holders retain all rights, title, and interest in the software.

 * -- GOVERNING LAW -- *
 This license is governed by and construed in accordance with the laws of Romania.
 Any legal action or proceeding related to this license shall be brought exclusively
 in the courts of Romania.

 [Weddify x Diaphan Stationery] © [2024] All rights reserved.
 -------------------------------------------------------------------------------------- **/

import React from 'react';
import AppStatic from "../../utils/AppStatic";
import AppButton from "../button/AppButton";
import LazyVideo from "../video/video";
import AppFeatures from "@/components/features/AppFeatures.tsx";
import {PiArrowBendLeftDownLight, PiHandTap, PiTable, PiUsersThree} from "react-icons/pi";
import {FaPlay, FaReact, FaShoppingBag} from "react-icons/fa";
import {MdTableBar} from "react-icons/md";
import {BsFileEarmarkExcel} from "react-icons/bs";
import {VscListSelection} from "react-icons/vsc";
import {GoNumber} from "react-icons/go";
import {IoEaselOutline} from "react-icons/io5";

const AppPlacement = () => {

    const featureItems = [
        {
            icon: <MdTableBar className="text-5xl m-auto"/>,
            text: AppStatic.appPlacementFirstFeature.ro.translation
        },
        {
            icon: <VscListSelection className="text-5xl m-auto"/>,
            text: AppStatic.appPlacementSecondFeature.ro.translation
        },
        {
            icon: <GoNumber className="text-5xl m-auto"/>,
            text: AppStatic.appPlacementThirdFeature.ro.translation
        },
        {
            icon: <PiUsersThree className="text-5xl m-auto"/>,
            text: AppStatic.appPlacementFourthFeature.ro.translation
        },
        {
            icon: <BsFileEarmarkExcel className="text-5xl m-auto"/>,
            text: AppStatic.appPlacementFifthFeature.ro.translation
        },
        {
            icon: <PiHandTap className="text-5xl m-auto"/>,
            text: AppStatic.appPlacementSixthFeature.ro.translation
        },
        {
            icon: <FaReact className="text-5xl m-auto"/>,
            text: AppStatic.appPlacementSeventhFeature.ro.translation
        },
        {
            icon: <PiTable className="text-5xl m-auto"/>,
            text: AppStatic.appPlacementEighthFeature.ro.translation
        },
        {
            icon: <IoEaselOutline className="text-5xl m-auto"/>,
            text: AppStatic.appPlacementNinthFeature.ro.translation
        }
    ];

    // @ts-ignore
    return (
        <>
            <div className="relative text-mono-1000">
                <div className="grid grid-cols-1 gap-5 xl:grid-cols-2 items-center">
                    <div>
                        <h3 className="text-4xl font-bold md:text-6xl mb-2">
                            {AppStatic.appStaticHookPlacement.ro.translation}
                        </h3>
                        <p className="mt-10 font-thin mb-6 tracking-wider">{AppStatic.appPlacementFirstProposition.ro.translation}</p>
                        <p className="mb-6 font-thin tracking-wider">{AppStatic.appPlacementSecondProposition.ro.translation}</p>
                        <p className="mb-4 font-bold">{AppStatic.appPlacementAdditionalHook.ro.translation}</p>
                        <div>
                            <div className="mt-8 mb-10 flex flex-wrap gap-2">
                                <AppButton data={{
                                    action: "scroll",
                                    id: "app-plans",
                                    name: AppStatic.mainBuyCta.ro.translation,
                                    icon: <FaShoppingBag className="f-2"/>,
                                    extraClass: "border-white!"
                                }}/>
                                <AppButton data={{
                                    action: "scroll",
                                    id: "app-placement-video",
                                    name: AppStatic.mainTryPlacement.ro.translation,
                                    icon: <FaPlay className="f-2"/>,
                                    extraClass: "bg-white! text-black! border-black!",
                                }}/>
                            </div>
                            <div
                                className="font-thin text-xs text-black italic mb-8">*{AppStatic.ivyDisclaimerPlacement.ro.translation}</div>
                        </div>
                    </div>
                    <div className="relative rounded-xl flex justify-center app-video">
                        <LazyVideo
                            className="w-full md:w-75p h-full min-h-auto lg:min-h-[500px]"
                            src="/clips/placement/weddify-placement-promo.mp4"
                            muted={true} loop={true} controls={false} autoPlay={true}></LazyVideo>
                    </div>
                </div>
            </div>
            <AppFeatures featureItems={featureItems}/>
            <div className="grid grid-cols-1 my-10 gap-5 items-center">
                <div id="app-placement-video" className="relative flex justify-center app-video">
                    <video
                        poster="/images/weddify-placement-poster.webp"
                        autoPlay={false}
                        className={"mt-10 rounded-2xl border border-gray-200 max-w-4xl w-full mx-auto block shadow-2xl transition-shadow duration-300"}
                        muted={false}
                        loop={false}
                        controls={true}
                        playsInline>
                        <source src="/clips/placement/weddify-placement-example.mp4" type="video/mp4"/>
                        Your browser does not support the video tag.
                    </video>
                </div>
            </div>
            <div className="pt-10 flex text-sm gap-2 justify-center items-center">
                <PiArrowBendLeftDownLight/> {AppStatic.appViewReviewsBlock.ro.translation}
            </div>
        </>
    );
}

export default AppPlacement;
